import "./index.css";
import "./styles/progressbar-spinner.css";
import "./styles/graphik-fonts.css";
import "./styles/knockout-fonts.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/pathway-gothic-one/index.css"; // TODO: remove this legacy font, use Knockout Web instead
import "@fontsource-variable/league-gothic/standard.css"; // TODO: remove this legacy font, use Knockout instead
import "helpers/rollbar";

import App from "App";
import React from "react";
import { createRoot } from "react-dom/client";

const element = document.getElementById("root");
const root = createRoot(element);
root.render(<App />);
